// Brew methods a user can record on a check-in (how they brewed the cup).
// Mirrors the API's `apps/api-cf/src/app/rating/brew-type.ts` allow-list and the
// `chk_rating_brew_type` DB constraint — keep the three in sync.
export const BREW_TYPES = [
  { id: 'espresso', label: 'Espresso' },
  { id: 'pourover', label: 'Pour over' },
  { id: 'filter', label: 'Filter' },
] as const;

export type BrewType = (typeof BREW_TYPES)[number]['id'];

export function brewTypeLabel(id: BrewType): string {
  return BREW_TYPES.find((brew) => brew.id === id)?.label ?? id;
}
